import gql from 'graphql-tag';

export const GET_COMPETITION_BY_ID = gql`
  query publicGetCompetitionById($id: ID!) {
    publicGetCompetitionById(id: $id) {
      name
      categoriesList {
        id
        name
      }
      countriesList {
        id
        name
      }
    }
  }
`;

export const GET_NOMINATIONS_FOR_PUBLIC_VOTING = gql`
  query getNominationsForPublicVoting(
    $competitionId: ID!
    $categoryId: ID
    $countryId: ID
    $nominationName: String
  ) {
    getNominationsForPublicVoting(
      competitionId: $competitionId
      categoryId: $categoryId
      countryId: $countryId
      nominationName: $nominationName
    ) {
      id
      name
      logo {
        title
        link
      }
      individualName
      isCompanyNomination
      webSite
      category {
        id
        name
      }
      country {
        id
        name
      }
    }
  }
`;

export const EMAIL_PUBLIC_VOTE = gql`
  mutation emailPublicVote($vote: EmailPublicVoteInput!) {
    emailPublicVote(vote: $vote)
  }
`;

export const FACEBOOK_PUBLIC_VOTE = gql`
  mutation facebookPublicVote($vote: FacebookPublicVoteInput!) {
    facebookPublicVote(vote: $vote)
  }
`;

export const GET_PUBLIC_NOMINATION_BY_ID = gql`
  query getPublicNominationById($id: ID!) {
    getPublicNominationById(id: $id) {
      id
      logo {
        link
        title
      }
      individualName
      isCompanyNomination
      name
      webSite
      category {
        id
        name
      }
      country {
        id
        name
      }
    }
  }
`;

export const GET_NOMINATION_BY_ID = gql`
  query getNominationById($id: ID!) {
    getNominationById(id: $id) {
      editable
      country {
        flag
        iso2
      }
      categories {
        id
        name
        typeForms {
          id
          title
        }
      }
      finalizedCategories {
        id
        name
      }
      competition {
        id
        name
        date {
          startDate
          endDate
        }
      }
      questionaryResult {
        id
        name
        typeForm {
          id
          formName
          answersList
          questionsList
        }
      }
    }
  }
`;

export const REMOVE_VOTE_WITH_FB = gql`
  mutation RemovePublicUserVoter($voteInfo: RemoveFacebookPublicVoteInput!) {
    removePublicUserVoter(voteInfo: $voteInfo)
  }
`;

export const GET_PUBLIC_VOTER_COMPETITIONS = gql`
  query getPublicVoterCompetitions($publicVoterId: String!) {
    getPublicVoterCompetitions(publicVoterId: $publicVoterId) {
      name
      date {
        startDate
        endDate
      }
      countriesList {
        name
        iso2
        iso3
        flag
      }
      voteCounter
    }
  }
`;
